<template>
    <div>
        <section>
            <div class="top-nav-div">
                <div class="top-nav-elements">
                    <a href="#" class="link-block-42 w-inline-block">
                        <img :src="require('@/assets/images/NewSelf_Logo.png')" 
                             sizes="(max-width: 479px) 100vw, 84.03125px"
                             loading="lazy" 
                             class="image-294">
                    </a>
                    <div class="form-nav-div">
                        <a href="#" @click.prevent="handleBack" class="back-link w-inline-block">
                            <div class="text-block-507">&lt;-</div>
                        </a>
                        <div class="form-progress-div">
                            <div>
                                <div class="text-block-508">Step <strong>{{ questionId }}</strong> of <strong>{{ totalQuestions }}</strong></div>
                            </div>
                            <div class="form-precent-div">
                                <div class="text-block-509"><strong>{{ Math.round(((questionId - 1) / totalQuestions) * 100) }}%</strong> Complete</div>
                            </div>
                        </div>
                    </div>
                    <div class="div-block-1442">
                    <div class="text-block-505"></div>
                </div>
                </div>
            </div>
        </section>

        <section class="section-7">
            <div class="questions-div">
                <!-- Hair Loss Location -->
                <div class="question-container" v-if="questionId === 1">
                    <div class="question-div-2">
                        <div class="text-block-513">Where are you noticing hair loss or thinning?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleHairLossLocation">
                                <label v-for="location in hairLossLocations" :key="location" class="w-checkbox checkbox-field-15">
                                    <input type="checkbox" 
                                           :value="location" 
                                           v-model="formData.hairLossLocation" 
                                           class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label">{{ location }}</span>
                                </label>
                                <input type="submit" 
                                       class="form-button w-button" 
                                       value="Next ->"
                                       :disabled="!formData.hairLossLocation.length">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Hair Loss Severity -->
                <div class="question-container" v-if="questionId === 2">
                    <div class="question-div-2">
                        <div class="text-block-513">How much hair have you lost?</div>
                        <div class="felix-form-block w-form">
                            <a v-for="option in hairLossSeverityOptions" 
                               :key="option"
                               href="#" 
                               @click.prevent="handleHairLossSeverity(option)" 
                               class="link-block-30 w-inline-block">
                                <div class="text-block-545">{{ option }}</div>
                                <div class="text-block-546">-></div>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Previous Treatments -->
                <div class="question-container" v-if="questionId === 3">
                    <div class="question-div-2">
                        <div class="text-block-513">Have you tried or do you currently use hair loss treatments?</div>
                        <div class="felix-form-block w-form">
                            <div class="div-block-1487">
                                <a href="#" @click.prevent="handlePreviousTreatments('Yes')" class="button-68 w-button">Yes</a>
                                <a href="#" @click.prevent="handlePreviousTreatments('No')" class="button-68 w-button">No</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Treatment Types and Effectiveness -->
                 <!-- Treatment Types and Effectiveness -->
                <div class="question-container" v-if="questionId === 4 && formData.previousTreatments === 'Yes'">
                    <div class="question-div-2">
                    <!-- Initial Treatment Selection -->
                    <div v-if="!formData.treatments.length || !showTreatmentEffectiveness">
                        <div class="text-block-513">What treatments did you receive?</div>
                        <div class="felix-form-block w-form">
                        <form @submit.prevent="handleTreatmentTypes">
                            <label v-for="treatment in treatmentOptions" 
                                :key="treatment" 
                                class="w-checkbox checkbox-field-15">
                            <input type="checkbox" 
                                    :value="treatment" 
                                    v-model="formData.treatments" 
                                    class="w-checkbox-input checkbox-11">
                            <span class="checkbox-label-12 w-form-label">{{ treatment }}</span>
                            </label>
                            <textarea v-if="formData.treatments.includes('Other')"
                                    v-model="formData.otherTreatments"
                                    class="text-field-43 w-input"
                                    placeholder="Please specify other treatments..."
                                    required></textarea>
                            <input type="submit" 
                                class="form-button w-button" 
                                value="Next"
                                :disabled="!isValidTreatmentSelection">
                        </form>
                        </div>
                    </div>

                    <!-- Treatment Effectiveness Questions -->
                    <div v-else>
                        <div class="text-block-513">
                        How effective was {{ currentTreatmentQuestion.name }} for you?
                        </div>
                        <div class="felix-form-block w-form">
                        <a v-for="option in treatmentEffectivenessOptions" 
                            :key="option"
                            href="#" 
                            @click.prevent="handleTreatmentEffectiveness(currentTreatmentQuestion.type, option)" 
                            class="link-block-30 w-inline-block">
                            <div class="text-block-545">{{ option }}</div>
                            <div class="text-block-546">-></div>
                        </a>
                        </div>
                    </div>
                    </div>
                </div>

                <!-- Additional Symptoms -->
                <div class="question-container" v-if="questionId === 5">
                    <div class="question-div-2">
                        <div class="text-block-513">Have you noticed any of the following?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleSymptoms">
                                <label v-for="symptom in symptomOptions" 
                                       :key="symptom" 
                                       class="w-checkbox checkbox-field-15">
                                    <input type="checkbox" 
                                           :value="symptom" 
                                           v-model="formData.symptoms" 
                                           class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label">{{ symptom }}</span>
                                </label>
                                <input type="submit" 
                                       class="form-button w-button" 
                                       value="Next ->"
                                       :disabled="!formData.symptoms.length">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Continue with remaining questions... -->
                 <!-- Medical Conditions -->
                <div class="question-container" v-if="questionId === 6">
                    <div class="question-div-2">
                        <div class="text-block-513">Do you have or have you ever had any of the following conditions?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleMedicalConditions">
                                <label v-for="condition in medicalConditions" 
                                       :key="condition" 
                                       class="w-checkbox checkbox-field-15">
                                    <input type="checkbox" 
                                           :value="condition" 
                                           v-model="formData.conditions" 
                                           class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label">{{ condition }}</span>
                                </label>
                                <input type="submit" 
                                       class="form-button w-button" 
                                       value="Next ->"
                                       :disabled="!formData.conditions.length">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Medications -->
                <div class="question-container" v-if="questionId === 7">
                    <div class="question-div-2">
                        <div class="text-block-513">Do you take any prescribed or over-the-counter medications, including vitamins and supplements?</div>
                        <div class="felix-form-block w-form">
                            <div class="div-block-1487">
                                <a href="#" @click.prevent="handleMedications('Yes')" class="button-68 w-button">Yes</a>
                                <a href="#" @click.prevent="handleMedications('No')" class="button-68 w-button">No</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Medication Details -->
                <div class="question-container" v-if="questionId === 8 && formData.takesMedications === 'Yes'">
                    <div class="question-div-2">
                        <div class="text-block-513">What medication(s) are you taking?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleMedicationDetails">
                                <textarea v-model="formData.medicationDetails"
                                        class="text-field-43 w-input"
                                        placeholder="Please list all medications..."
                                        required></textarea>
                                <input type="submit" 
                                       class="form-button w-button" 
                                       value="Next ->"
                                       :disabled="!formData.medicationDetails.trim()">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Medication Allergies -->
                <div class="question-container" v-if="questionId === 9">
                    <div class="question-div-2">
                        <div class="text-block-513">Do you suffer from any allergies to medications?</div>
                        <div class="felix-form-block w-form">
                            <div class="div-block-1487">
                                <a href="#" @click.prevent="handleAllergies('Yes')" class="button-68 w-button">Yes</a>
                                <a href="#" @click.prevent="handleAllergies('No')" class="button-68 w-button">No</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Allergy Details -->
                <div class="question-container" v-if="questionId === 10 && formData.hasAllergies === 'Yes'">
                    <div class="question-div-2">
                        <div class="text-block-513">Which medications and what was the reaction?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleAllergyDetails">
                                <textarea v-model="formData.allergyDetails"
                                        class="text-field-43 w-input"
                                        placeholder="Please describe your medication allergies..."
                                        required></textarea>
                                <input type="submit" 
                                       class="form-button w-button" 
                                       value="Next ->"
                                       :disabled="!formData.allergyDetails.trim()">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Additional Information -->
                <div class="question-container" v-if="questionId === 11">
                    <div class="question-div-2">
                        <div class="text-block-513">Do you have any specific questions or comments for your provider?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleAdditionalInfo">
                                <textarea v-model="formData.additionalInfo"
                                        class="text-field-43 w-input"
                                        placeholder="Type your message here..."></textarea>
                                <input type="submit" 
                                       class="form-button w-button" 
                                       value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Consent -->
                <div class="question-container" v-if="questionId === 12">
                    <div class="question-div-2">
                        <div class="text-block-513">Please read and acknowledge the following consent:</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleFinalSubmit">
                                <div class="consent-text">{{ consentText }}</div>
                                <label class="w-checkbox checkbox-field-15">
                                    <input type="checkbox" 
                                           v-model="formData.consent"
                                           required
                                           class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label">
                                        I acknowledge and agree to the above
                                    </span>
                                </label>
                                <input type="submit" 
                                       class="form-button w-button" 
                                       value="Submit"
                                       :disabled="!formData.consent">
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'HairLossQuestionnaire',
    data() {
        return {
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            questionId: 1,
            totalQuestions: 12,
            questionHistory: [1],
            showTreatmentEffectiveness: false,
            currentTreatmentIndex: 0,
            formData: {
                hairLossLocation: [],
                hairLossSeverity: '',
                previousTreatments: null,
                treatments: [],
                otherTreatments: '',
                treatmentEffectiveness: {},
                symptoms: [],
                conditions: [],
                takesMedications: null,
                medicationDetails: '',
                hasAllergies: null,
                allergyDetails: '',
                additionalInfo: '',
                consent: false
            },
            hairLossLocations: [
                'Along the hairline',
                'At the crown',
                'All over (patchy)',
                'Nowhere yet but I\'d like to prevent future hair loss'
            ],
            hairLossSeverityOptions: [
                'A little (Only I notice it)',
                'Some (Those close to me notice it)',
                'A lot (It is obvious to everyone)'
            ],
            treatmentOptions: [
                'Oral minoxidil',
                'Topical minoxidil or Rogaine',
                'Oral Finasteride or Propecia',
                'Topical finasteride',
                'Steroid injections in the scalp',
                'Other'
            ],
            treatmentEffectivenessQuestions: [
                { type: 'oral_minoxidil', name: 'Oral minoxidil' },
                { type: 'topical_minoxidil', name: 'Topical minoxidil or Rogaine' },
                { type: 'oral_finasteride', name: 'Oral Finasteride or Propecia' },
                { type: 'topical_finasteride', name: 'Topical finasteride' },
                { type: 'steroid_injections', name: 'Steroid injections in the scalp' }
            ],
            treatmentEffectivenessOptions: [
                'Yes it worked well',
                'No it wasn\'t effective',
                'No I had side effects such as redness itching burning rash',
                'Other'
            ],
            symptomOptions: [
                'Redness or rashes on scalp',
                'Pain, soreness, burning and/or tingling in areas of hair loss',
                'Recurrent pus bumps or open sores on scalp',
                'Partial or complete loss of eyebrows or eyelashes',
                'None of the above'
            ],
            medicalConditions: [
                'Heart conditions, surgeries, high blood pressure or symptoms related to the heart',
                'Stroke',
                'Pheochromocytoma (adrenal gland tumor)',
                'Pulmonary hypertension',
                'Prostate cancer',
                'Kidney disease',
                'Liver diseases',
                'Erectile Dysfunction',
                'Mental or behavioral health conditions',
                'None of the above'
            ],
            consentText: `I have filled out a medical intake form that will be used by a board-certified physician licensed in my state to make a medical treatment plan for me.

I understand all the questions that have been asked of me.

The information that I have provided is accurate and complete.

I am the patient who is consenting to be evaluated for treatment via telehealth.`
        }
    },
    computed: {
  isValidTreatmentSelection() {
    return this.formData.treatments.length > 0 && 
           (!this.formData.treatments.includes('Other') || 
            (this.formData.treatments.includes('Other') && this.formData.otherTreatments.trim()))
  },

  currentTreatmentQuestion() {
    const selectedTreatments = this.formData.treatments
      .filter(treatment => treatment !== 'Other')
      .map(treatment => this.treatmentEffectivenessQuestions.find(q => q.name === treatment))
      .filter(Boolean)

    return selectedTreatments[this.currentTreatmentIndex] || null
  },

  hasMoreTreatmentsToAnswer() {
    const selectedTreatments = this.formData.treatments
      .filter(treatment => treatment !== 'Other')
      .map(treatment => this.treatmentEffectivenessQuestions.find(q => q.name === treatment))
      .filter(Boolean)

    return this.currentTreatmentIndex < selectedTreatments.length - 1
  }
},
    methods: {
        getProgress() {
            return Math.round(((this.questionHistory.length - 1) / this.totalQuestions) * 100)
        },

        handleBack() {
            if (this.questionId === 4 && this.showTreatmentEffectiveness) {
            if (this.currentTreatmentIndex > 0) {
                // Go back to previous treatment effectiveness question
                this.currentTreatmentIndex--
                // Clear the answer for the current treatment
                const currentTreatment = this.currentTreatmentQuestion
                if (currentTreatment) {
                delete this.formData.treatmentEffectiveness[currentTreatment.type]
                }
            } else {
                // Go back to treatment selection
                this.showTreatmentEffectiveness = false
                this.currentTreatmentIndex = 0
                this.formData.treatmentEffectiveness = {}
            }
            } else {
            // Original back logic
            if (this.questionHistory.length > 1) {
                this.questionHistory.pop()
                this.questionId = this.questionHistory[this.questionHistory.length - 1]
                
                // Reset treatment state if going back from another question
                if (this.questionId !== 4) {
                this.showTreatmentEffectiveness = false
                this.currentTreatmentIndex = 0
                }
            }
            }
        },

        nextQuestion() {
            if (this.questionId < this.totalQuestions) {
                let nextQuestionId = this.getNextQuestionId()
                this.questionId = nextQuestionId
                this.questionHistory.push(nextQuestionId)
            }
            window.scrollTo(0, 0)
        },

        getNextQuestionId() {
            const currentId = this.questionId
            
            switch (currentId) {
                case 3: // Previous Treatments question
                    if (this.formData.previousTreatments === 'No') {
                        return 5 // Skip to symptoms
                    }
                    return 4

                case 7: // Medications
                    if (this.formData.takesMedications === 'No') {
                        return 9 // Skip medication details
                    }
                    return 8

                case 9: // Allergies
                    if (this.formData.hasAllergies === 'No') {
                        return 11 // Skip allergy details
                    }
                    return 10

                default:
                    return currentId + 1
            }
        },

        handleHairLossLocation() {
            if (this.formData.hairLossLocation.length > 0) {
                this.nextQuestion()
            }
        },

        handleHairLossSeverity(option) {
            this.formData.hairLossSeverity = option
            this.nextQuestion()
        },

        handlePreviousTreatments(answer) {
            this.formData.previousTreatments = answer
            this.nextQuestion()
        },

        shouldShowTreatmentEffectiveness(treatmentType, index) {
            return (
                this.questionId === 4 &&
                this.formData.previousTreatments === 'Yes' &&
                this.formData.treatments.includes(this.treatmentEffectivenessQuestions[index].name) &&
                !this.formData.treatmentEffectiveness[treatmentType]
            )
        },

        handleTreatmentTypes() {
            if (this.isValidTreatmentSelection) {
            // Check if any treatments need effectiveness feedback
            const hasEffectivenessQuestions = this.formData.treatments
                .some(treatment => this.treatmentEffectivenessQuestions
                .find(q => q.name === treatment))

            if (hasEffectivenessQuestions) {
                this.showTreatmentEffectiveness = true
                this.currentTreatmentIndex = 0
            } else {
                this.nextQuestion()
            }
            }
        },

        handleTreatmentEffectiveness(treatmentType, response) {
            // Save the response
            this.formData.treatmentEffectiveness[treatmentType] = response

            if (this.hasMoreTreatmentsToAnswer) {
            // Move to next treatment
            this.currentTreatmentIndex++
            } else {
            // Reset treatment effectiveness state
            this.showTreatmentEffectiveness = false
            this.currentTreatmentIndex = 0
            // Move to next question
            this.nextQuestion()
            }
        },

        handleSymptoms() {
            if (this.formData.symptoms.length > 0) {
                this.nextQuestion()
            }
        },

        handleMedicalConditions() {
            if (this.formData.conditions.length > 0) {
                if (this.formData.conditions.length > 1 && 
                    this.formData.conditions.includes('None of the above')) {
                    this.formData.conditions = this.formData.conditions.filter(condition =>
                        condition !== 'None of the above'
                    )
                }
                this.nextQuestion()
            }
        },

        handleMedications(answer) {
            this.formData.takesMedications = answer
            this.nextQuestion()
        },

        handleMedicationDetails() {
            if (this.formData.medicationDetails.trim()) {
                this.nextQuestion()
            }
        },

        handleAllergies(answer) {
            this.formData.hasAllergies = answer
            this.nextQuestion()
        },

        handleAllergyDetails() {
            if (this.formData.allergyDetails.trim()) {
                this.nextQuestion()
            }
        },

        handleAdditionalInfo() {
            if (this.formData.additionalInfo.trim() !== undefined) {
                this.nextQuestion()
            }
        },

        async handleFinalSubmit() {
            if (!this.formData.consent) {
                return
            }

            try {
                const payload = {
                    formObj: {
                        consentsSigned: this.formData.consent,
                        selfReportedMeds: this.formData.medicationDetails || "None",
                        allergies: this.formData.allergyDetails || "None",
                        medicalConditions: this.formData.conditions.join(', ') || "None",
                        Q1: `Where are you noticing hair loss or thinning? Available Options ${this.hairLossLocations.join(', ')}`,
                        A1: this.formData.hairLossLocation.join(', '),
                        Q2: `How much hair have you lost? Available Options ${this.hairLossSeverityOptions.join(', ')}`,
                        A2: this.formData.hairLossSeverity,
                        Q3: "Have you tried or do you currently use hair loss treatments?Available Options Yes, No",
                        A3: this.formData.previousTreatments,
                    },
                    pharmacyId: "default",
                    masterId: Date.now().toString(),
                    company: process.env.VUE_APP_COMPANY_ID,
                    visitType: "hairloss"
                }

                // Add treatment related questions if applicable
                if (this.formData.previousTreatments === 'Yes') {
                    payload.formObj.Q4 = `What treatments did you receive? Available Options: ${this.treatmentOptions.join(', ')}`
                    payload.formObj.A4 = this.formData.treatments.join(', ')
                    
                    // Add treatment effectiveness answers
                    Object.entries(this.formData.treatmentEffectiveness).forEach(([type, response], index) => {
                        const questionNumber = 4 + (index + 1)
                        const treatmentName = this.treatmentEffectivenessQuestions.find(q => q.type === type)?.name
                        payload.formObj[`Q${questionNumber}`] = `How effective was ${treatmentName}?`
                        payload.formObj[`A${questionNumber}`] = response
                    })
                }

                // Add remaining questions
                const remainingQuestions = {
                    5: {
                        Q: `Have you noticed any of the following symptoms? Available Options: ${this.symptomOptions.join(', ')}`,
                        A: this.formData.symptoms.join(', ')
                    },
                    6: {
                        Q: `Do you have or have you ever had any of the following conditions?  Available Options: ${this.medicalConditions.join(', ')}`,
                        A: this.formData.conditions.join(', ')
                    },
                    7: {
                        Q: "Do you take any prescribed or over-the-counter medications?  Available Options: Yes , No",
                        A: this.formData.takesMedications
                    },
                    8: {
                        Q: "What medications are you taking?",
                        A: this.formData.medicationDetails || "None"
                    },
                    9: {
                        Q: "Do you suffer from any allergies to medications?   Available Options: Yes , No",
                        A: this.formData.hasAllergies
                    },
                    10: {
                        Q: "Which medications and what was the reaction?",
                        A: this.formData.allergyDetails || "None"
                    },
                    11: {
                        Q: "Do you have any specific questions or comments for your provider?",
                        A: this.formData.additionalInfo || "None"
                    },
                    12: {
                        Q: "Consent confirmation",
                        A: "I consent"
                    }
                }

                // Add remaining questions to payload
                Object.entries(remainingQuestions).forEach(([num, qa]) => {
                    payload.formObj[`Q${num}`] = qa.Q
                    payload.formObj[`A${num}`] = qa.A
                })

                const response = await this.$axios.post(
                    `${this.baseUrl}/forms/assessment-form/hairloss/${this.$route.params.id}`, 
                    payload
                )

                if (response.data.status === 'success') {
                    this.$router.push('/success');
                } else {
                    throw new Error('Form submission failed')
                }
            } catch (error) {
                console.error('Error submitting form:', error)
                alert('There was an error submitting your form. Please try again.')
            }
        }
    }
}
</script>

<style scoped>
.question-container {
    margin-bottom: 2rem;
}

.consent-text {
    margin-bottom: 1rem;
    padding: 1rem;
    background-color: #f8f9fa;
    border-radius: 4px;
}

textarea.w-input {
    height: auto;
    min-height: 100px;
    width: 100%;
    padding: 8px;
}

.checkbox-field-15 {
    display: block;
    margin-bottom: 10px;
}

.form-button {
    margin-top: 1rem;
}

.button-68 {
    margin-right: 1rem;
}

.form-progress-div {
    margin: 1rem 0;
}
</style>